import isEqual from 'date-fns/is_equal'
import isBefore from 'date-fns/is_before'
import moment from 'moment'

export function getDate(date) {
  const localStorageDate = localStorage.getItem(date)
  if (localStorageDate) {
    const parsedDate = moment(localStorageDate)
    if (parsedDate.isValid()) return parsedDate.toDate()
  }
  return null
}

export function getDynamicDateType(state) {
  const {currentUser: {dynamicDateType}} = state
  if (dynamicDateType) return dynamicDateType

  return localStorage.getItem('dynamicDateType') || null
}

function getStartDynamicDate(dynamicDateType, today, timezone) {
  timezone = timezone || moment.defaultZone?.name || moment.tz.guess()
  const mmToday = moment.tz(today, timezone)
  switch (dynamicDateType) {
    case 'today':
      return mmToday

    case 'yesterday':
      return mmToday.subtract(1, 'day').startOf('day')

    case 'thisWeek':
      return mmToday.startOf('isoWeek')

    case 'lastWeek':
      return mmToday.subtract(1, 'week').startOf('isoWeek')

    case 'last28':
      return mmToday.subtract(28, 'day').startOf('day')

    case 'thisMonth':
      return mmToday.startOf('month')

    case 'lastMonth':
      return mmToday.subtract(1, 'month').startOf('month')

    case 'thisYear':
      return mmToday.startOf('year')

    case 'lastYear':
      return mmToday.subtract(1, 'year').startOf('year')
  }
}

function getEndDynamicDate(dynamicDateType, today, timezone) {
  let endDate = null
  timezone = timezone || moment.defaultZone?.name || moment.tz.guess()
  const mmToday = moment.tz(today, timezone)
  switch (dynamicDateType) {
    case 'today':
      endDate = mmToday.endOf('day')
      break

    case 'yesterday':
      endDate = mmToday.subtract(1, 'day').endOf('day')
      break

    case 'thisWeek':
      endDate = mmToday.endOf('isoWeek')
      break

    case 'lastWeek':
      endDate = mmToday.subtract(1, 'week').endOf('isoWeek')
      break

    case 'last28':
      return mmToday.subtract(1, 'day').endOf('day')
    case 'thisMonth':
      endDate = mmToday.endOf('month')
      break

    case 'lastMonth':
      endDate = mmToday.subtract(1, 'month').endOf('month')
      break

    case 'thisYear':
      endDate = mmToday.endOf('year')
      break

    case 'lastYear':
      endDate = mmToday.subtract(1, 'year').endOf('year')
      break
  }

  return isBefore(mmToday.endOf('day'), endDate) ? mmToday.endOf('day') : endDate
}

export function getDynamicDateRange(dynamicDateType, today, start, end, timezone) {
  if (!dynamicDateType) return {start, end}

  return {
    start: getStartDynamicDate(dynamicDateType, today, timezone),
    end: getEndDynamicDate(dynamicDateType, today, timezone)
  }
}

export function getStartDate(state) {
  const {today} = state
  const dynamicDateType = getDynamicDateType(state)
  const storedDate = getDate('startDate')
  const isToday = isEqual(moment(storedDate).startOf('day'), today)

  if (dynamicDateType) {
    return getStartDynamicDate(dynamicDateType, today).toDate()
  } else {
    const isStoredDateValid = storedDate && (isToday || isBefore(storedDate, today))
    const result = isStoredDateValid ? moment(storedDate) : moment(today).subtract(4, 'weeks')
    return result.toDate()
  }
}

export function getEndDate(state, startDate) {
  const {today} = state
  const dynamicDateType = getDynamicDateType(state)
  const storedDate = getDate('endDate')

  if (dynamicDateType) {
    return getEndDynamicDate(dynamicDateType, today).toDate()
  } else {
    const isStoredDateValid = storedDate && isBefore(storedDate, today)
    const result = isStoredDateValid ? moment(storedDate) : moment(today).clone().endOf('day')
    return result.toDate()
  }
}

export const resources = [
  '@metric/impression:count',
  
  '@metric/session',
  '@metric/session:count',
  '@metric/session:pagesPerSession',
  '@metric/session:duration',
  '@metric/session:valuePerVisit',
  '@metric/session:valuePerVisit-last-click',
  '@metric/session:valuePerVisit-divvit',
  '@metric/session:valuePerVisit-nonDirectTouch',
  '@metric/session:valuePerVisit-nonDirectLastClick',
  '@metric/session:valuePerVisit-nonDirectClicks',
  '@metric/session:valuePerVisit-nonDirectLastTouch',
  '@metric/session:bounceRate',
  '@metric/session:checkoutAbandonmentRate',
  '@metric/session:failedDiscoveryRate',
  '@metric/session:conversionRate',

  '@metric/order',
  '@metric/order:count',
  '@metric/order:count-rf-touched',
  '@metric/order:count-ftd-touched',

  '@metric/order:count-every-session',
  '@metric/order:count-touchpoint',
  '@metric/order:count-rf-touchpoint',
  '@metric/order:count-ftd-touchpoint',
  '@metric/order:count-rf-touchpoint-per-conversion',
  '@metric/order:count-ftd-touchpoint-per-conversion',
  '@metric/order:count-session',
  '@metric/order:count-rf-session',
  '@metric/order:count-ftd-session',
  '@metric/order:count-impression',
  '@metric/order:count-rf-impression',
  '@metric/order:count-ftd-impression',
  '@metric/order:aov',
  '@metric/order:aov-last-click',
  '@metric/order:aov-divvit',
  '@metric/order:aov-non-direct-touch',
  '@metric/order:aov-non-direct-last-click',
  '@metric/order:aov-non-direct-clicks',
  '@metric/order:aov-non-direct-last-touch',

  '@metric/cost',
  '@metric/cost:total',
  '@metric/cost:perVisit',
  '@metric/cost:perOrder-rf',
  '@metric/cost:perOrderLast-rf',
  '@metric/cost:perOrder-divvit-rf',
  '@metric/cost:perOrder-non-direct-last-touch-rf',
  '@metric/cost:perOrder-ftd',
  '@metric/cost:perOrderLast-ftd',
  '@metric/cost:perOrder-divvit-ftd',
  '@metric/cost:perOrder-non-direct-last-touch-ftd',



  '@metric/cost:roi',
  '@metric/cost:roi-linear',
  '@metric/cost:roi-divvit',
  '@metric/cost:roi-non-direct-last-touch',

  '@metric/cost:ofSales',
  '@metric/cost:ofSales-linear',
  '@metric/cost:ofSales-divvit',
  '@metric/cost:ofSales-non-direct-last-touch',

  '@metric/cost:ofAd',
  '@metric/cost:frequency',
  '@metric/cost:impressions',
  '@metric/cost:purchase_roas',
  '@metric/cost:conversions',
  '@metric/cost:cpc',
  '@metric/cost:cpm',
  '@metric/cost:ctr',
  '@metric/cost:cost_per_conversion',
  '@metric/customer',
  '@metric/customer:cac',
  '@metric/customer:cac-divvit',
  '@metric/customer:cac-last-click',
  '@metric/customer:cac-non-direct-last-touch',

  '@metric/customer:new',
  '@metric/customer:new-linear',
  '@metric/customer:new-divvit',
  '@metric/customer:new-non-direct-last-click',
  '@metric/customer:new-non-direct-clicks',
  '@metric/customer:new-non-direct-touch',
  '@metric/customer:new-non-direct-last-touch',

  '@metric/customer:new-percent',
  '@metric/customer:new-percent-linear',
  '@metric/customer:new-percent-divvit',
  '@metric/customer:new-percent-non-direct-last-click',
  '@metric/customer:new-percent-non-direct-clicks',
  '@metric/customer:new-percent-non-direct-touch',
  '@metric/customer:new-percent-non-direct-last-touch',

  '@metric/session:count-uniq',

  // Revenue
  '@metric/order:total',
  '@metric/order:total-divvit',
  '@metric/order:total-last-click',
  '@metric/order:total-non-direct-last-click',
  '@metric/order:total-non-direct-clicks',
  '@metric/order:total-non-direct-touch',
  '@metric/order:total-non-direct-last-touch',

  '@metric/order:count-divvit',
  '@metric/order:count-last-click',
  '@metric/order:count-non-direct-touch',
  '@metric/order:count-non-direct-last-click',
  '@metric/order:count-non-direct-clicks',
  '@metric/order:count-non-direct-last-touch',

  '@metric/order:regCount-non-direct-touch',
  '@metric/order:regCount-non-direct-last-click',
  '@metric/order:regCount-non-direct-clicks',
  '@metric/order:regCount-non-direct-last-touch',

  '@metric/order:ftdCount-non-direct-touch',
  '@metric/order:ftdCount-non-direct-last-click',
  '@metric/order:ftdCount-non-direct-clicks',
  '@metric/order:ftdCount-non-direct-last-touch',
  
  '@metric/order:regImpact-non-direct-touch',
  '@metric/order:regImpact-non-direct-last-click',
  '@metric/order:regImpact-non-direct-clicks',
  '@metric/order:regImpact-non-direct-last-touch',

  '@metric/order:ftdImpact-non-direct-touch',
  '@metric/order:ftdImpact-non-direct-last-click',
  '@metric/order:ftdImpact-non-direct-clicks',
  '@metric/order:ftdImpact-non-direct-last-touch',

  '@features/pageInsight',
  '@features/analytics',
  '@features/costIntegration',
  '@features/users',
  '@features/sites',
  '@features/reports',
  '@features/categoryMappings',
  '@features/channelMappings',
  '@features/orderExplorer',
  '@features/editProfile',
  '@features/channelMapping',
  '@features/editSite',
  '@features/account',
  '@features/billing',
  '@features/createReport',
  '@features/myIntegrations',
  '@features/allIntegrations',
  '@features/landingPages',

  '@dashboardChannels/direct',
  '@dashboardChannels/referral',
  '@dashboardChannels/email',
  '@dashboardChannels/organic',
  '@dashboardChannels/social_organic',
  '@dashboardChannels/sem',
  '@dashboardChannels/price_comparison',
  '@dashboardChannels/social_ppc',
  '@dashboardChannels/display',
  '@dashboardChannels/affiliate',
  '@dashboardChannels/retargeting',
  '@dashboardChannels/onsite',
  '@dashboardChannels/unknown'
]



// WEBPACK FOOTER //
// ./client/redux/modules/currentUser/utils.js